import styles from './AdvancedFiltersButton.css';
import { forwardRef } from 'react';
import { FilterButton } from '../FilterButton';

interface IAdvancedFiltersButtonProps {
  onClick: VoidFunction;
  showBadge?: boolean;
  children: string;
}

export const AdvancedFiltersButton = forwardRef<HTMLDivElement, IAdvancedFiltersButtonProps>(
  function AdvancedFiltersButton({ onClick, showBadge, children }, ref) {
    return (
      <div data-name="AdvancedFiltersContainer" className={styles['button']} ref={ref}>
        <FilterButton onClick={onClick}>{children}</FilterButton>
        {showBadge ? <div className={styles['badge']} /> : null}
      </div>
    );
  },
);
